export enum ErrorType {
  XSD_VALIDATION = 'XSD_VALIDATION',
  SCHEMATRON_VALIDATION = 'SCHEMATRON_VALIDATION',
  SEND_TO_VEDI = 'SEND_TO_VEDI',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_ALREADY_IN_GROUP = 'USER_ALREADY_IN_GROUP',
  NOTICE_LOCKED = 'NOTICE_LOCKED',
}
